// extracted by mini-css-extract-plugin
export var content_wrapper = "styles-module--content_wrapper--dde62";
export var mobilePosts = "styles-module--mobilePosts--1be8a";
export var wrapper = "styles-module--wrapper--8defc";